var React = require('react');

function User (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"12","cy":"6.38","r":"4.64","key":0}),React.createElement("path",{"d":"M21.34,22.26a.9.9,0,0,0,.89-1c-.57-4.54-4.93-8.07-10.23-8.07S2.34,16.71,1.77,21.25a.9.9,0,0,0,.89,1H21.34Z","key":1})]);
}

User.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 24 24"};

module.exports = User;

User.default = User;
